import React, { useState, useEffect } from "react"
import { get } from 'lodash'
import { makeStyles } from "@material-ui/core"
import DeleteIcon from '@material-ui/icons/Delete'
import StarIcon from '@material-ui/icons/Star'
import { Checkbox } from "@material-ui/core"
import AttachMoneyIcon from "@material-ui/icons/AttachMoney"
import LocalOfferIcon from '@material-ui/icons/LocalOffer'
import { CurrencyValue } from './CurrencyValue'
import { getCurrencySymbol } from '../utils/detectCountryCode'
import { loggedInUser, getLoggedInUserDisplayName, getLoggedInUserId } from '../v2_actions/auth'
import { countryList } from '../v2_actions/country'
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked'
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked'

const useStyles = makeStyles({
    missing_photograph_container: {
        border: "1px solid lightgray"
    },
    noSelectedPhotograph: {
        "&:hover": {
            outline: "2px solid #06befa"
        }
    },
    imgStyle: {
      transition: "transform .135s cubic-bezier(0.0,0.0,0.2,1),opacity linear .15s",
      width: '100%',
      border: 'none',
      height: '100%',
      maxWidth: '100%',
      maxHeight: '100%',
      objectFit: 'cover'
    },
    cont: {
      backgroundColor: "#fff",
      position: "relative",
    },
    photographIcons: {
        position: "absolute",
        top: "0px",
        left: "0px",
        zIndex:"99",
        display: "flex"
    },
    photographIcon: {
        borderRadius: "20px",
        border: "1px solid black",
        backgroundColor: "white",
        display: "flex",
        padding: "2px",
        marginLeft: "3px"
    },
    photographActions: {
        position: "absolute",
        top: "0px",
        right: "0px",
        zIndex: "99",
        display: "flex",
        borderRadius: "20px",
        border: "1px solid black",
        backgroundColor: "white",
        padding: "2px",
    },
    photographAction: {
        cursor: "pointer",
        alignItems: "center",
        display: "flex",
        padding: "2px",
        "&:hover": {
            backgroundColor: "gray",
        },
        marginLeft: "3px",
        borderRadius: "10px"
    },
    photographUnadornedAction: {
        cursor: "pointer",
        backgroundColor: "white",
        display: "flex",
        padding: "2px",
        "&:hover": {
            backgroundColor: "gray",
        },
        marginLeft: "3px"
    },
    soldBadge: {
        position: "absolute",
        top: "6px",
        left: "6px",
        backgroundColor: "#2196f3",
        color: "white",
        borderRadius: "50%",
        width: "24px",
        height: "24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: "100"
    }
})

export const GalleryPhotograph = ({
    index,
    photo,
    margin,
    direction,
    top,
    left,
    country_id,
    getIsSelected,
    getIsActivated,
    isMapPhotograph,
    showSoldIcons,
    onActivatePhotograph,
    onSelectPhotograph,
    onEditPhotograph,
    onUnSelectPhotograph,
    onSetAsMapPhotograph,
    onDeletePhotograph,
    onDeletePhotographWithoutGallerySizeFileInfo
}) => {

    const classes = useStyles()
    const isSelected = getIsSelected(photo)
    const isActivated = getIsActivated(photo)
    const country = countryList.getCountryForId(country_id)
    const [markedForDelete, setMarkedForDelete] = useState(false)
    const photograph_info = Object.assign({},
                                          get(photo, "gallery_size_file_info", {}),
                                          { height_pixels: 'auto' })

  
  useEffect(() => {
    if (photograph_info && photograph_info.download_url == null) {
      setMarkedForDelete(true)
    }
  }, [photo])

  useEffect(() => {
    if (markedForDelete) {
      onDeletePhotographWithoutGallerySizeFileInfo(photo)
    }
  }, [markedForDelete])

  
  
    const onTogglePhotographSelected = () => {
        if ( isSelected ) {
            onUnSelectPhotograph(photo)
        } else {
            onSelectPhotograph(photo)
        }
    }
    
    const renderIcons = () => {
        return (
            <div className={classes.photographIcons}>
              {isMapPhotograph &&
               <div className={classes.photographIcon}>
                 <StarIcon />
               </div>
              }
            </div>            
        )
    }
    
    const renderActions = () => {
        return (
            <div className={classes.photographActions}>
              <div className={classes.photographAction} onClick={() => onDeletePhotograph(photo)}>
                <DeleteIcon />
              </div>
              <div className={classes.photographAction} onClick={() => onSetAsMapPhotograph(photo)}>
                <StarIcon />
              </div>
              <div className={classes.photographUnadornedAction} onClick={() => onTogglePhotographSelected()}>
                {isSelected && <RadioButtonCheckedIcon /> }
                {!isSelected && <RadioButtonUncheckedIcon /> }
              </div>
              <div className={classes.photographAction} onClick={() => onEditPhotograph(photo)}>
                <CurrencyValue value={photo.price} country={country} />
              </div>
              
            </div>
        )
    }

  return (
        <div
          key={photo.id}
          style={{ margin, height: photograph_info.height_pixels }}
          className={classes.cont}
          onMouseEnter={() => onActivatePhotograph(photo)}
          onMouseLeave={() => onActivatePhotograph(null)}
        >
          { isActivated && renderActions() }
          { renderIcons() }
          { showSoldIcons && get(photo, "purchased_trolley_photographs", []).length > 0 &&
            <div className={classes.soldBadge}>
              <LocalOfferIcon style={{ fontSize: '16px' }} />
            </div>
          }
          {  get(photo, "gallery_size_file_info") &&
             <div className={classes.galleryImageWrapper}>
               <img src={get(photo, ["gallery_size_file_info", "download_url"])}
                    className={classes.imgStyle}
                    height={photograph_info.height_pixels}
               />
             </div>
          }
          {  !get(photo, "gallery_size_file_info") &&
             <div className={classes.missing_photograph_container}>
               <div>{get(photo, "photo_name")}</div>
               Still resizing and adding watermarks, retry in a few minutes. If this message still shows, please contact the help desk
             </div>
          }
    </div>
    )
}

